import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import api from 'services/api';
import { viagensAPI } from 'services/apiRest';

import TripActions from '../ducks/trip';

export function* getCtes() {
  try {
    const data = yield api
      .firestore()
      .collection('ctes')
      .orderBy('created_at', 'desc')
      .get();

    const ctes = data.docs.map((item) => item.data());

    yield put(TripActions.getCtesSuccess(ctes));
  } catch (err) {
    yield put(TripActions.getCtesFailure(err));
  }
}

export function* confirmPayment({ id, closeModal }) {
  try {
    yield api.firestore().collection('ctes').doc(id).update({ status: 1 });
    yield put(TripActions.getCtesRequest());
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Pagamento confirmado',
      })
    );

    closeModal();
  } catch (err) {
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao confirmar pagamento',
      })
    );
    yield put(TripActions.confirmPaymentFailure(err));
  }
}

export function* cancelPayment({ id }) {
  try {
    yield api.firestore().collection('ctes').doc(id).update({ status: 3 });
    yield put(TripActions.getCtesRequest());
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Pagamento cancelado',
      })
    );
  } catch (err) {
    console.log(err);
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao cancelar pagamento',
      })
    );
    yield put(TripActions.confirmPaymentFailure(err));
  }
}

// CRUD de Viagens
export function* getViagens({ filtros = {} }) {
  try {
    const viagens = yield call(viagensAPI.listar, filtros);
    yield put(TripActions.getViagensSuccess(viagens));
  } catch (err) {
    yield put(TripActions.getViagensFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao buscar viagens',
        message: err.message,
      })
    );
  }
}

export function* addViagem({ viagem, closeModal }) {
  try {
    const viagemCriada = yield call(viagensAPI.criar, viagem);
    
    // Adicionar ao Redux imediatamente para feedback rápido
    yield put(TripActions.addViagemSuccess(viagemCriada));
    
    // Recarregar lista completa do servidor para garantir sincronização
    yield put(TripActions.getViagensRequest());
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Viagem criada com sucesso',
      })
    );
    
    // Executar callback se fornecido (ex: redirecionar)
    if (closeModal && typeof closeModal === 'function') {
      closeModal();
    }
  } catch (err) {
    yield put(TripActions.addViagemFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao criar viagem',
        message: err.message,
      })
    );
  }
}

export function* updateViagem({ id, viagem, closeModal }) {
  try {
    const viagemAtualizada = yield call(viagensAPI.atualizar, id, viagem);
    yield put(TripActions.updateViagemSuccess(viagemAtualizada));
    
    // Recarregar lista de viagens após atualizar
    yield put(TripActions.getViagensRequest());
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Viagem atualizada com sucesso',
      })
    );
    if (closeModal) closeModal();
  } catch (err) {
    yield put(TripActions.updateViagemFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao atualizar viagem',
        message: err.message,
      })
    );
  }
}

export function* removeViagem({ id }) {
  try {
    yield call(viagensAPI.deletar, id);
    yield put(TripActions.removeViagemSuccess(id));
    
    // Recarregar lista de viagens após remover
    yield put(TripActions.getViagensRequest());
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Viagem removida com sucesso',
      })
    );
  } catch (err) {
    yield put(TripActions.removeViagemFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro ao remover viagem',
        message: err.message,
      })
    );
  }
}
